/**
 * 정산 관련 유틸리티 함수
 */
import { formatCurrency } from "@/shared/utils/formatter";
import { STORAGE_KEYS } from '@/shared/constants/storageKeys';
import {
    getPartnerStatusBadge,
    getRiderContractStatusBadge,
    getStatusBadge,
    getGradeBadge,
    getGradeBadgeClass,
    getStatusBadgeClass,
    getRiderContractStatusBadgeClass,
    getPreAccountBadgeClass,
    getPreAccountBadgeText,
    getPartnerRowClassName,
    getRiderRowClassName,
    isPartnerAccountDisabled,
    isRiderAccountDisabled,
} from '@/shared/utils/accountingLabelHelpers';

const formatNumber = (num: number | null | undefined): string => {
    if (num === null || num === undefined) return '-';
    return formatCurrency(num);
};

const handleSendMoney = (
    partnerName: string,
    amount: string,
    suppId?: string,
    riderId?: string
) => {
    if (suppId) {
        const prefillPayload = {
            suppId,
            riderId,
            deductTarget: riderId ? '라이더' : '협력사',
            partnerName,
            amount,
        };
        try {
            sessionStorage.setItem(STORAGE_KEYS.PARTNER_DEDUCTION_PREFILL, JSON.stringify(prefillPayload));
        } catch {
            // sessionStorage 저장 실패는 무시
        }
    }

    window.dispatchEvent(new CustomEvent('dashboard:navigate', {
        detail: { page: 'partner_deduction_history' },
    }));
};

export const accountingUtils = {
    getPartnerStatusBadge,
    getRiderContractStatusBadge,
    getStatusBadge,
    getGradeBadge,
    getGradeBadgeClass,
    formatNumber,
    handleSendMoney,
    getStatusBadgeClass,
    getPartnerRowClassName,
    isPartnerAccountDisabled,
    getRiderContractStatusBadgeClass,
    getPreAccountBadgeClass,
    getPreAccountBadgeText,
    getRiderRowClassName,
    isRiderAccountDisabled,
};
